<template>
  <div>
    <a-row>
      <g-master name="behavior"
                :endpoint="competencyMaster.endpoint"
                :tableSetup="competencyMaster.tableSetup"
                :parentData="evParentData"
                :modalFieldsSetup="competencyMaster.modalFieldsSetup"
                :actions="competencyMaster.actions"
                :key="key"
      >
        <template slot="masterModal" slot-scope="{record}">

          <a-row :gutter="[16, 16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Descripción: ">
                <a-input
                  v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Nombre corto: ">
                <a-input
                  v-decorator="['short_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="level_competency"
                          label="Grupo: "
                          :formItemConfig="fiOptions"
                          :decorator="['id_group',{ rules: [{ required: false, message: 'Valor requerido' }]}]">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>

    </a-row>
  </div>
</template>
<script>
  export default {
    props: ['id_competency', 'dateInitial'],
    mounted () {
      let now = moment().format('Y-MM-DD')
      if (this.dateInitial >= now) {
        this.competencyMaster.tableSetup.actions.actions[0] =
        {
          name: 'masterEdit',
          text: 'Editar',
          permisos: [],
          props: {size: 'small', type: 'link', icon: 'edit'}
        }
        this.competencyMaster.tableSetup.actions.actions[1] = {
          name: 'masterDelete',
          text: 'Eliminar',
          permisos: [],
          props: {size: 'small', icon: 'delete', type: 'link'}
        }
        this.competencyMaster.actions[0] = {
          name: 'masterCreate',
          text: 'Crear',
          permisos: [],
          props: {icon: 'plus', type: 'button'}
        }
        this.key++
      }
    },
    data () {
      return {
        key:0,
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        competencyMaster: {
          actions: [],
          endpoint: 'behavior',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_behavior'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Grupo', dataIndex: 'descripcion', sorter: true},
              {title: 'Nombre corto', dataIndex: 'short_name', sorter: true}
            ],
            actions: {
              actions: []
            }
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'id_group'},
            {name: 'short_name'}
          ]
        }
      }
    },
    computed: {
      evParentData () {
        return {
          id_competency: this.id_competency
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Comportamiento.vue